import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStudentMe } from '../../roster/hooks/useStudentMe';
import { acquireDashboardProgressInvalidationBridge } from './dashboardProgressInvalidationBridge';

/** Mount once at app root to coalesce tutor progress events → dashboard query invalidation. */
export function AppDashboardProgressBridge() {
  const queryClient = useQueryClient();
  const { enabled: studentRosterEnabled } = useStudentMe();

  useEffect(() => {
    if (!studentRosterEnabled) return;
    return acquireDashboardProgressInvalidationBridge(queryClient);
  }, [queryClient, studentRosterEnabled]);

  return null;
}
